import { render, staticRenderFns } from "./PackagingRequirementsTwo.vue?vue&type=template&id=573a3a9e&scoped=true"
import script from "./PackagingRequirementsTwo.vue?vue&type=script&lang=js"
export * from "./PackagingRequirementsTwo.vue?vue&type=script&lang=js"
import style0 from "./PackagingRequirementsTwo.vue?vue&type=style&index=0&id=573a3a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a3a9e",
  null
  
)

export default component.exports